module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.55b43504.png";